import type { ChiTietPhieuXuatKho, PhieuXuatKho } from '@/types/schemas';
import { roundNumber } from '@/lib/formatUtils';

type HoaDonDetailForPhieuXuat = ChiTietPhieuXuatKho & {
  tk_gv_data?: ChiTietPhieuXuatKho['tk_du_data'];
};

type HoaDonForPhieuXuat = Omit<Partial<PhieuXuatKho>, 'chi_tiet'> & {
  ngay_px?: string;
  chi_tiet?: HoaDonDetailForPhieuXuat[];
};

/**
 * Transform data from HoaDonBanHang to PhieuXuatKho format
 * @param hoaDonData - Data from HoaDonBanHang
 * @returns Transformed data for PhieuXuatKho form
 */
export const transformDataFromHoaDon = (hoaDonData?: HoaDonForPhieuXuat | null): PhieuXuatKho => {
  const chi_tiet =
    hoaDonData?.chi_tiet?.map(row => ({
      uuid: row.uuid || String(row.line || ''),
      line: row.line,
      ma_vt_data: row.ma_vt_data,
      dvt: typeof row.dvt === 'string' ? row.dvt : row.ma_vt_data?.dvt || '',
      dvt_data: row.dvt_data,
      ma_kho_data: row.ma_kho_data,

      // Optional foreign keys
      ma_bp_data: row.ma_bp_data,
      ma_vv_data: row.ma_vv_data,
      ma_hd_data: row.ma_hd_data,
      ma_dtt_data: row.ma_dtt_data,
      ma_ku_data: row.ma_ku_data,
      ma_phi_data: row.ma_phi_data,
      ma_sp_data: row.ma_sp_data,
      ma_cp0_data: row.ma_cp0_data,

      // Account fields
      tk_vt_data: row.tk_vt_data,
      tk_du_data: row.tk_gv_data,
      ma_nx: row.ma_nx,
      ma_lsx: row.ma_lsx || '',

      // Numeric fields
      so_luong: roundNumber(row.so_luong, 6),
      gia_nt: roundNumber(Number(row.tien_nt) / Number(row.so_luong), 6),
      gia: roundNumber(Number(row.tien_nt) / Number(row.so_luong), 6),
      tien_nt: roundNumber(row.tien_nt, 6),
      tien: roundNumber(row.tien, 6),

      px_dd: row.px_dd || false
    })) || [];

  const result = {
    ma_gd: 'NB',
    ngay_ct: hoaDonData?.ngay_ct || hoaDonData?.ngay_px || new Date().toISOString().split('T')[0], // Format as YYYY-MM-DD for date input
    dien_giai: hoaDonData?.dien_giai || `Xuất kho theo hóa đơn: ${hoaDonData?.so_ct || ''}`,
    ma_nt: hoaDonData?.ma_nt,
    ty_gia: hoaDonData?.ty_gia || 1,
    status: hoaDonData?.status == '5' ? '8' : hoaDonData?.status,
    t_so_luong: roundNumber(hoaDonData?.t_so_luong, 6),
    ma_kh_data: hoaDonData?.ma_kh_data,
    chi_tiet
  };

  return result;
};
